import {RouteRecordRaw} from "vue-router";

const Factory: RouteRecordRaw[] = [{
    path: "factory",
    name: "H5Factory",
    component: () => import("@/page/h5/factory/index.vue"),
}]

export default Factory
